import { RouteObject } from "react-router-dom";
import { HomePage } from "./ui/HomePage";

export const homeRoute: RouteObject = {
  path: "/",
  element: <HomePage />,
};
